import { TFunction } from 'react-i18next';
import { BuildingTypes, IOrderDelivery } from '@/models/orders.model';

export const getOrderDeliveryDetailsData = (t: TFunction, deliveryData: IOrderDelivery) => {
  const deliveryDetailsData: (string | null)[] = [];

  if (deliveryData.building_type === BuildingTypes.FLAT) {
    const floorData = deliveryData?.floor
      ? `${deliveryData.floor} ${t('order_details_delivery_details_building_floor')}`
      : null;

    const flatData = deliveryData?.flat_number
      ? `${t('order_details_delivery_details_building_flat')} ${deliveryData.flat_number}`
      : null;

    const freightElevatorData = deliveryData?.freight_elevator
      ? t('order_details_delivery_details_freight_elevator_yes')
      : t('order_details_delivery_details_freight_elevator_no');

    deliveryDetailsData.push(
      t('order_details_delivery_details_building_type_flat'),
      floorData,
      flatData,
      freightElevatorData,
    );
  } else {
    deliveryDetailsData.push(t('order_details_delivery_details_building_type_private'));
  }

  return deliveryDetailsData.filter((item) => !!item);
};
